/**
 * @generated SignedSource<<a2e75fd6e572c4ff48351c7dd92041c9>>
 * @relayHash 1edf32cecbc318c96e43793f60a16fbf
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/572.0.0-2026-08-11T14:53:16.313Z/NftProfileSectionCollectionPaginationQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileSectionCollectionPaginationQuery$variables = {
  collectionCursor?: string | null;
  collectionFirst?: number | null;
  fetchUser: boolean;
  userId: string;
  username?: string | null;
  walletAddress?: string | null;
};
export type NftProfileSectionCollectionPaginationQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"NftProfileSectionCollection_viewer">;
  };
};
export type NftProfileSectionCollectionPaginationQuery = {
  response: NftProfileSectionCollectionPaginationQuery$data;
  variables: NftProfileSectionCollectionPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionFirst"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "username"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "walletAddress"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "collectionCursor"
  },
  {
    "kind": "Literal",
    "name": "excludeOwnerCreatedItems",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "collectionFirst"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "ownerAddresses.0",
        "variableName": "walletAddress"
      }
    ],
    "kind": "ListValue",
    "name": "ownerAddresses"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "ownerProfileUsernames.0",
        "variableName": "username"
      }
    ],
    "kind": "ListValue",
    "name": "ownerProfileUsernames"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "excludeCanceled",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicProfile",
  "kind": "LinkedField",
  "name": "publicProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileName",
      "storageKey": null
    },
    (v8/*:: as any*/)
  ],
  "storageKey": null
},
v10 = [
  (v7/*:: as any*/),
  (v9/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ensDomain",
    "storageKey": null
  },
  (v8/*:: as any*/)
],
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rate",
    "storageKey": null
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpUrl",
  "storageKey": null
},
v13 = [
  (v7/*:: as any*/),
  (v8/*:: as any*/)
],
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "auctionId",
    "storageKey": null
  },
  (v5/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EthereumAddressType",
    "kind": "LinkedField",
    "name": "contractAddress",
    "plural": false,
    "selections": (v13/*:: as any*/),
    "storageKey": null
  },
  (v8/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileSectionCollectionPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NftProfileSectionCollection_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftProfileSectionCollectionPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": "NftItemSearchConnection",
            "kind": "LinkedField",
            "name": "nftItemSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "NftItemSearchEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NftDigitalArtMetadataMedia",
                                "kind": "LinkedField",
                                "name": "media",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mimeType",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "webUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "posterFrameUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoThumb",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "edition",
                                "storageKey": null
                              }
                            ],
                            "type": "NftDigitalArtMetadata",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v4/*:: as any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": [
                          (v5/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "currentBid",
                            "plural": false,
                            "selections": (v6/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EtherAmount",
                            "kind": "LinkedField",
                            "name": "reservePrice",
                            "plural": false,
                            "selections": (v6/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "winnerAddress",
                            "plural": false,
                            "selections": (v10/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftItem",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherRates",
                                "kind": "LinkedField",
                                "name": "etherRates",
                                "plural": true,
                                "selections": (v11/*:: as any*/),
                                "storageKey": null
                              },
                              (v8/*:: as any*/),
                              (v12/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NftConversionRateEvent",
                            "kind": "LinkedField",
                            "name": "endedConversionRates",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EtherRates",
                                "kind": "LinkedField",
                                "name": "rates",
                                "plural": true,
                                "selections": (v11/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "creatorAddress",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "sellerAddress",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          },
                          (v8/*:: as any*/)
                        ],
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "wasBurned",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LinkData",
                        "kind": "LinkedField",
                        "name": "linkData",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "path",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLinkable",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "importErrorReason",
                        "storageKey": null
                      },
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItemLikes",
                        "kind": "LinkedField",
                        "name": "likes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "likeCount",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "creatorAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publicProfileUrl",
                            "storageKey": null
                          },
                          (v9/*:: as any*/),
                          (v8/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalSupply",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isERC1155",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EthereumAddressType",
                        "kind": "LinkedField",
                        "name": "ownerAddress",
                        "plural": false,
                        "selections": (v10/*:: as any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tokenUri",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftTokenContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v8/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EthereumAddressType",
                            "kind": "LinkedField",
                            "name": "addressWithFields",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          },
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                              }
                            ],
                            "concreteType": "NftItemBalance",
                            "kind": "LinkedField",
                            "name": "balanceForUser",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "balance",
                                "storageKey": null
                              },
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EthereumAddressType",
                                "kind": "LinkedField",
                                "name": "ownerAddress",
                                "plural": false,
                                "selections": (v13/*:: as any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "alias": "recentAuction",
                        "args": (v4/*:: as any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": (v14/*:: as any*/),
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      (v12/*:: as any*/),
                      {
                        "alias": "auction",
                        "args": (v4/*:: as any*/),
                        "concreteType": "NftAuction",
                        "kind": "LinkedField",
                        "name": "mostRecentAuction",
                        "plural": false,
                        "selections": (v14/*:: as any*/),
                        "storageKey": "mostRecentAuction(excludeCanceled:true)"
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "filters": [
              "ownerProfileUsernames",
              "ownerAddresses",
              "excludeOwnerCreatedItems"
            ],
            "handle": "connection",
            "key": "NftProfileSectionCollection_nftItemSearch",
            "kind": "LinkedHandle",
            "name": "nftItemSearch"
          },
          (v8/*:: as any*/),
          {
            "alias": "nftBenignNeglect",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftBenignNeglect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
          },
          {
            "alias": "walletConnectFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "allowWalletConnect"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"allowWalletConnect\")"
          },
          {
            "alias": "isNftAuctionV2Enabled",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "nftAuctionV2"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"nftAuctionV2\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/572.0.0-2026-08-11T14:53:16.313Z/NftProfileSectionCollectionPaginationQuery",
    "metadata": {},
    "name": "NftProfileSectionCollectionPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8abfcc6c40cad2a4e9430d4d1ae35c5c";

export default node;
